export const validateFields = (activeTab: string, formData: any) => {
    let newErrors: { [key: string]: string } = {};
    const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    switch (activeTab) {
        case 'business-info': {
            const business = formData.businessInfo;

            if (!business.facilityName)
                newErrors.businessFacilityName = 'Facility name is required';

            if (!business.address || business.address.trim() === '')
                newErrors.businessAddress = 'Address is required';

            if (!business.city || business.city.trim() === '')
                newErrors.businessCity = 'City is required';

            if (!business.state || business.state.trim() === '')
                newErrors.businessState = 'State is required';

            if (!business.zip || business.zip.trim() === '')
                newErrors.businessZip = 'Zip is required';

            if (!business.phone)
                newErrors.businessPhone = 'Phone is required';

            if (!business.businessType || !business.businessType.id)
                newErrors.businessType = 'Business Type is required';

            break;
        }

        case 'shipping-info': {
            const shipping = formData.shippingInfo;

            if ((!shipping.address || shipping.address.trim() === '') && !shipping.sameAsBusiness)
                newErrors.shippingAddress = 'Shipping address is required';
            if ((!shipping.city || shipping.city.trim() === '') && !shipping.sameAsBusiness)
                newErrors.shippingCity = 'Shipping city is required';

            if ((!shipping.state || shipping.state.trim() === '') && !shipping.sameAsBusiness)
                newErrors.shippingState = 'Shipping state is required';

            if ((!shipping.zip || shipping.zip.trim() === '') && !shipping.sameAsBusiness)
                newErrors.shippingZip = 'Shipping zip is required';

            if ((!shipping.deliveryOption.id || !shipping.deliveryOption))
                newErrors.shippingDeliveryOption = 'Delivery option is required';

            if ((!shipping.contact?.firstName || shipping.contact.firstName.trim() === ''))
                newErrors.shippingContactFirstName = 'First name is required';

            if ((!shipping.contact?.lastName || shipping.contact.lastName.trim() === ''))
                newErrors.shippingContactLastName = 'Last name is required';

            if ((!shipping.contact?.email || shipping.contact.email.trim() === '') || !isValidEmail(shipping.contact.email))
                newErrors.shippingContactEmail = 'Email is required';

            if ((!shipping.contact?.phone || shipping.contact.phone.trim() === ''))
                newErrors.shippingContactPhone = 'Phone is required';
            break;
        }
        case 'billing-info': {
            const billing = formData.billingInfo;

            if ((!billing.address || billing.address.trim() === '') && !billing.sameAsShipping)
                newErrors.billingAddress = 'Billing address is required';

            if ((!billing.city || billing.city.trim() === '') && !billing.sameAsShipping)
                newErrors.billingCity = 'Billing city is required';

            if ((!billing.state || billing.state.trim() === '') && !billing.sameAsShipping)
                newErrors.billingState = 'Billing state is required';

            if ((!billing.zip || billing.zip.trim() === '') && !billing.sameAsShipping)
                newErrors.billingZip = 'Billing zip is required';

            if ((!billing.contact?.firstName || billing.contact.firstName.trim() === ''))
                newErrors.billingContactFirstName = 'First name is required';

            if ((!billing.contact?.lastName || billing.contact.lastName.trim() === ''))
                newErrors.billingContactLastName = 'Last name is required';

            if ((!billing.contact?.email || billing.contact.email.trim() === '') || !isValidEmail(billing.contact.email))
                newErrors.billingContactEmail = 'Email is required';

            if ((!billing.contact?.phone || billing.contact.phone.trim() === ''))
                newErrors.billingContactPhone = 'Phone is required';
            
            if ((billing.isTaxExempt && billing.taxExemptFile === undefined))
                newErrors.billingTaxExempt = 'Document Required';

            break;
        }
        case 'contacts': {
            const { contacts } = formData.contactInfo;

            const validateContact = (contact: any, prefix: string) => {
                if (!contact.firstName || contact.firstName.trim() === '')
                    newErrors[`${prefix}FirstName`] = 'First name is required';
                if (!contact.lastName || contact.lastName.trim() === '')
                    newErrors[`${prefix}LastName`] = 'Last name is required';
                if (!contact.phone || contact.phone.trim() === '')
                    newErrors[`${prefix}Phone`] = 'Phone number is required';
                if ((!contact.email || contact.email.trim() === '') || !isValidEmail(contact.email))
                    newErrors[`${prefix}Email`] = 'Email is required';
            };

            if (contacts[0]) validateContact(contacts[0], 'primaryContact');
            if (!contacts[1].sameAsPrimary && contacts[1]) {
                validateContact(contacts[1], 'purchasingContact');
            }
            if (!contacts[2].sameAsPrimary && contacts[2]) {
                validateContact(contacts[2], 'accountsPayableContact');
            }

            break;
        }
    }

    return newErrors;
};
